export const venuePaths = {
  VENUE: "",
  VENUE_SELECT: "select",
  CREATE_VENUE: "create",
};
